import { Injectable, inject } from '@angular/core';

import { InspectionDBService } from '../db/inspection-db-service';
import { Resolve } from '@angular/router';
import { InspectionWithResultsDto } from '@core/api';

@Injectable()
export class InspectionsResolver implements Resolve<InspectionWithResultsDto[]> {
  private inspectionDbService = inject(InspectionDBService);

  public resolve() {
    return this.inspectionDbService.getAllInspectionsWithResults();
  }
}
